// extracted by mini-css-extract-plugin
export var indeterminate = "_4w-5";
export var md = "_4w-4";
export var semantic = "_4w-6";
export var sm = "_4w-3";
export var text = "_4w-7";
export var toggleInput = "_4w-0";
export var toggleSwitch = "_4w-1";
export var xs = "_4w-2";